import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Drag = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("rect", { x: "8", y: "8.5", width: "8", height: "2" }),
    React.createElement("rect", { x: "8", y: "3.5", width: "8", height: "2" }),
    React.createElement("rect", { x: "8", y: "13.5", width: "8", height: "2" }),
    React.createElement("rect", { x: "8", y: "18.5", width: "8", height: "2" })), 'Drag');
export default Drag;
